"use client";

import { Trans } from "@lingui/react/macro";
import { PenBoxIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAiChatUiContext } from "@/lib/ai/ai-chat-ui-context";
import { cn } from "@/lib/utils";

export function NewChatButton() {
  const { clearChatSelection, chatId } = useAiChatUiContext();
  const isActive = chatId === null;

  return (
    <Button
      onClick={clearChatSelection}
      size="sm"
      variant="ghost"
      className={cn(
        "font-medium w-full justify-start truncate",
        isActive
          ? "bg-primary/10 text-primary hover:bg-primary/10 hover:text-primary"
          : "text-foreground hover:bg-muted",
      )}
    >
      <PenBoxIcon className="mr-1.5 h-4 w-4" />
      <Trans>New Chat</Trans>
    </Button>
  );
}
